import {ResolvedPos} from "prosemirror-model";

export const getParentInGroupPos = (
    $pos: ResolvedPos,
    nodeTypeGroup: string
): number | undefined => {
    for (let depth = $pos.depth; depth >= 0; depth--) {
        const parent = $pos.node(depth)

        const { group } = parent.type.spec

        if (group && group.split(/\s+/).includes(nodeTypeGroup)) {
            return $pos.before(depth)
        }
    }
    return undefined;
}